import styled from "styled-components";
import {
  borderRadius,
  breakpoint,
  colors,
  space,
} from "shared/styles/constants";
import { TinyText } from "shared/styles";

export interface StyledEntryProps {
  isStriped?: boolean;
}

export const StyledEntryInfo = styled.div`
  display: flex;
  flex-direction: column;

  margin-right: auto;
  padding: 0 ${space.s};

  > * + * {
    margin-top: ${space.xs};
  }

  ${breakpoint("s", "down")} {
    padding: ${space.s} 0;
  }
`;

export const StyledEntry = styled.div<StyledEntryProps>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  padding: ${space.s};
  background-color: ${({ isStriped }) =>
    isStriped ? colors.grey1 : colors.blackLight};
  border-radius: ${borderRadius.m};

  ${breakpoint("s", "down")} {
    flex-direction: column;
  }

  @media print {
    display: table;
    page-break-inside: avoid;
    border-radius: 0;

    background-color: ${colors.grey6};
    width: 100%;
    margin-top: ${space.m};

    > * {
      display: table-cell;
      vertical-align: top;
      padding: 5px;
    }
  }
`;

export const ScheduleBlockEntryDateTime = styled(TinyText)`
  @media print {
    padding-left: ${space.s};
    page-break-inside: avoid;
  }
`;
